var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiselect__tag multiselect__tag--recipient"},[_c('ListItemIcon',{attrs:{"no-margin":true,"title":_vm.option.label,"avatar-size":24}}),_vm._v(" "),_c('Close',{staticClass:"delete-recipient",attrs:{"size":20},on:{"click":function($event){$event.preventDefault();return _vm.removeRecipient(_vm.option)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }